require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es7.symbol.observable.js
// module id = Oxke
// module chunks = 1